import Loadable from "../layout/Loadable";
import { lazy } from "react";
import AuthGuard from "../core/guard/AuthGuard";
import { RoutePath } from "./DynamicBreadcrumbPath";

//demo portal component list
const DemoLayout = Loadable(
  lazy(async () => await import("../layout/FullLayout"))
);
const Dashboard = Loadable(
  lazy(async () => await import("../views/dashboard/Dashboard"))
);

const NoPageFound = Loadable(
  lazy(async () => await import("../views/no-page-found/NoPageFound"))
);

//facial recog
const FaceRecogDashboard = Loadable(
  lazy(async () => await import("../views/face-recognition/FaceRecogDashboard"))
);
const FacialListView = Loadable(
  lazy(async () => await import("../views/face-recognition/ListView"))
);
const FacialDetailView = Loadable(
  lazy(async () => await import("../views/face-recognition/DetailView"))
);
const FacialDemoView = Loadable(
  lazy(async () => await import("../views/face-recognition/DemoView"))
);

//ocr
const OcrDashboard = Loadable(
  lazy(async () => await import("../views/ocr/OcrDashboard"))
);
const OcrListView = Loadable(
  lazy(async () => await import("../views/ocr/ListView"))
);
const OcrDetailView = Loadable(
  lazy(async () => await import("../views/ocr/DetailView"))
);
const OcrDemoView = Loadable(
  lazy(async () => await import("../views/ocr/DemoView"))
);

//ai
const AiAgentScoringDashboard = Loadable(
  lazy(
    async () =>
      await import("../views/ai-agent-scoring/AiAgentScoringDashboard")
  )
);
const AiAgentScoringListView = Loadable(
  lazy(async () => await import("../views/ai-agent-scoring/ListView"))
);
const AiAgentScoringDetailView = Loadable(
  lazy(async () => await import("../views/ai-agent-scoring/DetailView"))
);
const AiAgentScoringDemoView = Loadable(
  lazy(async () => await import("../views/ai-agent-scoring/DemoView"))
);


//capabilities components

//1. speech Transcription
const SpeechTranscriptionDashbaord = Loadable(
  lazy(
    async () =>
      await import("../views/speech-transcription/SpeechTranscriptionDashbaord")
  )
);
const ListViewSpeechTranscript = Loadable(
  lazy(
    async () =>
      await import("../views/speech-transcription/ListViewSpeechTranscript")
  )
);
const SpeechTranscriptionDemoView = Loadable(
  lazy(async () => await import("../views/speech-transcription/DemoView"))
);
const EMRScreenDemoPortal = Loadable(
  lazy(async () => await import("../views/speech-transcription/EMRScreenDemo"))
);

//2. Summarization
const SummarizationDashboard = Loadable(
  lazy(
    async () => await import("../views/summarization/SummarizationDashboard")
  )
);
const ListViewSummarization = Loadable(
  lazy(async () => await import("../views/summarization/ListViewSummarization"))
);
const SummarizationDemoView = Loadable(
  lazy(async () => await import("../views/summarization/NewDemoView"))
);

const DetailSummarization = Loadable(
  lazy(async () => await import("../views/summarization/DetailView"))
);

//3.chatbox
const NewChatBotDashboard = Loadable(
  lazy(async () => await import("../views/chatbox/NewChatBotDashboard"))
);
const ListViewChatbot = Loadable(
  lazy(async () => await import("../views/chatbox/ListViewChatbot"))
);

const ChatWithUsPage = Loadable(
  lazy(async () => await import("../views/chatbox/ChatWithUsPage"))
);
const ChatBoxTrelliChat = Loadable(
  lazy(async () => await import("../views/chatbox/NewChatBotTrelliChat"))
);
const NewChatBotTrelliTalk = Loadable(
  lazy(async () => await import("../views/chatbox/NewChatBotTrelliTalk"))
);

//call-evaluation
const AIEvaluationDashboard = Loadable(
  lazy(async () => await import("../views/ai-evaluation/Dashboard"))
);
const AIEvaluationListView = Loadable(
  lazy(async () => await import("../views/ai-evaluation/AIEvaluationList"))
);
const AIEvaluationListDetailView = Loadable(
  lazy(async () => await import("../views/ai-evaluation/AIEvaluationDetail"))
);
const ConversationalTagsList = Loadable(
  lazy(async () => await import("../views/ai-evaluation/ConversationalTagsList"))
);

// Agent
const AgentPerformanceDashboardStatic = Loadable(
  lazy(
    async () =>
      await import("../views/agent/dashboard/AgentPerformanceDashboardStatic")
  )
);

// Agent Level Scoring Vs Sentiment
const AgentLevelScoringVsSentiment = Loadable(
  lazy(
    async () =>
      await import("../views/agent/components/agent-level-scoring-vs-sentiment/AgentLevelScoringVsSentiment")
  )
);

// Agent Violation
const AgentViolation = Loadable(
  lazy(
    async () =>
      await import("../views/agent/components/agent-violation/AgentViolations")
  )
);

// Purpose of Call Distribution
const PurposeOfCallDistribution = Loadable(
  lazy(
    async () =>
      await import(
        "../views/agent/components/purpose-of-call-distribution/PurposeOfCallDistribution"
      )
  )
);

// manage template 

const TemplateView = Loadable(
  lazy(async ()=>await import("../views/manage-template/ListView"))
)


const AddTemplate = Loadable(
  lazy(async ()=>await import("../views/manage-template/AddTemplate"))
)
//mange User
const ManageUser =  Loadable(
  lazy(async ()=>await import("../views/manage-user/ListView"))
)


//knowledge Base
const KnowledgeBase = Loadable(
  lazy(
    async () =>
      await import("../views/knowledge-base/KnowledgeBaseRetrieval")
  )
);

// Call Pattern Analysis
const CallPatternAnalysis = Loadable(
  lazy(
    async () =>
      await import("../views/ai-evaluation/call-pattern-analysis/CallPatternAnalysis")
  )
);

// Call Pattern Analysis Detail
const CallPatternAnalysisDetail = Loadable(
  lazy(
    async () =>
      await import("../views/ai-evaluation/call-pattern-analysis-details/CallPatternAnalysisDetails")
  )
);


const routes = [
  {
    path: "",
    pathMatch: "full",
    element: Loadable(
      lazy(async () => await import("../views/authentication/Login"))
    ),
  },
  {
    path: "login",
    element: Loadable(
      lazy(async () => await import("../views/authentication/Login"))
    ),
  },
  {
    path: "demo-portal",
    element: <AuthGuard>{DemoLayout}</AuthGuard>,
    children: [
      {
        path: "/demo-portal",
        element: <AuthGuard>{Dashboard}</AuthGuard>,
      },
      {
        path: "/demo-portal/emr",
        element: <AuthGuard>{EMRScreenDemoPortal}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/facial-recognition",
        element: <AuthGuard>{FaceRecogDashboard}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/face-recognition/:type",
        element: <AuthGuard>{FacialListView}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/face-recognition/:type/:subtype",
        element: <AuthGuard>{FacialDetailView}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/face-recognition/demo",
        element: <AuthGuard>{FacialDemoView}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/ocr",
        element: <AuthGuard>{OcrDashboard}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/ocr/:type",
        element: <AuthGuard>{OcrListView}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/ocr/:type/:subtype",
        element: <AuthGuard>{OcrDetailView}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/ocr/demo",
        element: <AuthGuard>{OcrDemoView}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/ai-agent-scoring",
        element: <AuthGuard>{AiAgentScoringDashboard}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/ai-agent-scoring/:type",
        element: <AuthGuard>{AiAgentScoringListView}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/ai-agent-scoring/:type/:subtype",
        element: <AuthGuard>{AiAgentScoringDetailView}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/ai-agent-scoring/demo",
        element: <AuthGuard>{AiAgentScoringDemoView}</AuthGuard>,
      },
      {
        path: "/demo-portal/solutions/ai-agent-scoring/demo",
        element: <AuthGuard>{AiAgentScoringDemoView}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/speech-recognition",
        element: <AuthGuard>{SpeechTranscriptionDashbaord}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/speech-recognition/:type",
        element: <AuthGuard>{ListViewSpeechTranscript}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/speech-recognition/demo",
        element: <AuthGuard>{SpeechTranscriptionDemoView}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/summarization",
        element: <AuthGuard>{SummarizationDashboard}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/summarization/:type",
        element: <AuthGuard>{ListViewSummarization}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/summarization/detail",
        element: <AuthGuard>{DetailSummarization}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/summarization/demo",
        element: <AuthGuard>{SummarizationDemoView}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/chatbot",
        element: <AuthGuard>{NewChatBotDashboard}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/chatbot/:type",
        element: <AuthGuard>{ListViewChatbot}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/chatbot/chatWithUs",
        element: <AuthGuard>{ChatWithUsPage}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/chatbot/trelliChat",
        element: <AuthGuard>{ChatBoxTrelliChat}</AuthGuard>,
      },
      {
        path: "/demo-portal/capabilities/chatbot/trelliTalk",
        element: <AuthGuard>{NewChatBotTrelliTalk}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.aiEvaluationDashboard}`,
        element: <AuthGuard>{AIEvaluationDashboard}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.aiEvaluationList}`,
        element: <AuthGuard>{AIEvaluationListView}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.conversationalTagsList}`,
        element: <AuthGuard>{ConversationalTagsList}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.aiEvaluationDetail}/:userId`,
        element: <AuthGuard>{AIEvaluationListDetailView}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.agentPerformanceDashboard}`,
        element: <AuthGuard>{AgentPerformanceDashboardStatic}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.agentLevelScoringVsSentiment}`,
        element: <AuthGuard>{AgentLevelScoringVsSentiment}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.agentViolations}`,
        element: <AuthGuard>{AgentViolation}</AuthGuard>, 
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.purposeOfCallDistribution}`,
        element: <AuthGuard>{PurposeOfCallDistribution}</AuthGuard>, 
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.manageTemplate}`,
        element: <AuthGuard>{TemplateView}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.manageTemplate}/add`,
        element: <AuthGuard>{AddTemplate}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.manageTemplate}/:internalTemplateId`,
        element: <AuthGuard>{AddTemplate}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.manageUser}`,
        element: <AuthGuard>{ManageUser}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.knowledgeBase}`,
        element: <AuthGuard>{KnowledgeBase}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.callPatternAnalysis}`,
        element: <AuthGuard>{CallPatternAnalysis}</AuthGuard>,
      },
      {
        path: `/demo-portal/solutions/call-evaluation/${RoutePath.callPatternAnalysisDetails}/:type/:id`,
        element: <AuthGuard>{CallPatternAnalysisDetail}</AuthGuard>, 
      }
    ],
  }, 
  {
    path: "*",
    element: NoPageFound,
  },
];

export default routes;
